// extracted by mini-css-extract-plugin
export default {"categoriesBar":"CategoriesBar_categoriesBar__-G+Di","isSelected":"CategoriesBar_isSelected__8lr-k"};